module.exports = __webpack_public_path__ + "static/media/service6.fcb7e664.jpg";